// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import { fmt } from '../utils/common';

interface DetailsRowProps {
  label: string;
  value: string | React.ReactNode | null;
  isNumber?: boolean;
}
export const DetailsRow: React.FC<DetailsRowProps> = ({ label, value, isNumber }) => {
  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}>
      <Typography sx={{ textTransform: 'capitalize', flex: 1, mr: 1 }} variant="body2">
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          flex: 2,
          ml: 'auto',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {isNumber && typeof value === 'string' ? fmt(value, 2) : value}
      </Typography>
    </Box>
  );
};
